/*
 *   File : editUserDetail.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Success Modal
 *   Integrations : 25-01-2022
 *   Version : v1.0
 */

/*import packages*/
import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import $ from 'jquery';

/*import componets*/
import { Datepicker, Input, PhoneInput, Radio, TextArea } from '../../components/input/index';
import { SecondaryBtn, PrimaryBtn } from '../../components/cta/index';

/*import styles*/
import styles from '../../styles/components/addFaq.module.scss';
import SelectBox from '../dropdown/selectBox';

/*import services */
import devconfig from '../../config/config';
import APIPost from '../../services/postApi';
import APIGet from '../../services/getApi';
import moment from 'moment';
import { parsePhoneNumber } from 'react-phone-number-input'
import { FundsTab, Tab } from '../dataFormating';
import { Toast } from '../note';

export default function EditUser(props) {
	const [name, setName] = useState("");
	const [gender, setGender] = useState(null);
	const [dob, setDob] = useState("");
	const [maritalStatus, setMaritalStatus] = useState(null);
	const [email, setEmail] = useState("");
	const [occupation, setOccupation] = useState(null);
	const [annualIncome, setAnnualIncome] = useState("");
	const [wealthSource, setWealthSource] = useState(null);
	const [phone, setPhone] = useState("");
	const [countryCode, setCountryCode] = useState("");
	const [error, setError] = useState(null);
	const [permanentAddressLine1, setPermanentAddressLine1] = useState("");
	const [permanentAddressLine2, setPermanentAddressLine2] = useState("");
	const [permanentCity, setPermanentCity] = useState(null);
	const [permanentState, setPermanentState] = useState(null);
	const [permanentCountry, setPermanentCountry] = useState({
		label: "India",
		value: 251
	});
	const [permanentPin, setPermanentPin] = useState("");

	const [correspondanceAddressLine1, setCorrespondanceAddressLine1] = useState("");
	const [correspondanceAddressLine2, setCorrespondanceAddressLine2] = useState("");
	const [corresspondanceCity, setCorresspondanceCity] = useState(null);
	const [correspondanceState, setCorrespondanceState] = useState(null);
	const [correspondanceCountry, setCorrespondanceCountry] = useState({
		label: "India",
		value: 251
	});
	const [correspondancePin, setCorrespondancePin] = useState("");
	const [genderOptions, setGenderOptions] = useState([]);
	const [occupationOptions, setOccupationOptions] = useState([]);
	const [maritalOptions, setMaritalOptions] = useState([]);
	const [sourceOptions, setSourceOptions] = useState([]);
	const [countryOptions, setCountryOptions] = useState([]);
	const [stateOptions, setStateOptions] = useState([]);
	const [cityOptions, setCityOptions] = useState([]);
	const [cityOptions1, setCityOptions1] = useState([]);

	const [nomineeDetails, setNomineeDetails] = useState([{
		email: "",
		mobile: "",
		nominee_id: null,
		country_code: "+91",
		address_line1: "",
		state: null,
		state_name: "",
		city: null,
		city_name: "",
		country: {
			label: "India",
			value: 251
		},
		pincode: "",
		nominee_relationship: null,
		proof_number: "",
		guardian_relationship: null,
		proof_type: null,
		cityOptions: [],
		name: "",
		dob: null,
		allocation: "",
		guardian_name: "",
		guardian_pan: "",
	}]);


	const [isSame, setIsSame] = useState(true);
	const [nomineeTabs, setNomineeTabs] = useState(nomineeDetails.map((item, index) => `Nominee ${index + 1}`));
	const [selectedNominee, setSelectedNominee] = useState(1);
	const [identityProofTypes, setIdentityProofTypes] = useState([]);
	const [nomineeRelations, setNomineeRelations] = useState([]);
	const [guardianRelations, setGuardianRelations] = useState([]);

	const [statePName, setStatePName] = useState("");
	const [stateCName, setStateCName] = useState("");

	const [cityPName, setCityPName] = useState("");
	const [cityCName, setCityCName] = useState("");


	const [toastMessage, setToastMessage] = useState(null);
	const [apiLoader, setApiLoader] = useState(false);
	const [nomineeAvailable, setNomineeAvailable] = useState(true);

	const [nomineeVisibility, setNomineeVisibility] = useState(null);
	const [nomineeVisibilityStatuses, setNominivisibilityStatuses] = useState([]);

	useEffect(() => {
		if (props.data !== null) {
			if (props.data.data?.overview.name) {
				setName(props.data.data?.overview.name)
			}
			if (props.data.data?.overview.dob) {
				setDob(moment(props.data.data?.overview.dob, "DD MMM YYYY").format("DD-MM-YYYY"))
			}

			if (props.data.data?.overview.marital_status) {
				setMaritalStatus({
					label: props.data.data?.overview.marital_status,
					value: props.data.data?.overview.marital_status_id
				})
			}

			if (props.data.data?.overview.gender) {
				setGender({
					label: props.data.data?.overview.gender,
					value: props.data.data?.overview.gender_id
				})
			}

			if (props.data.data?.overview.phone) {
				const parsed = parsePhoneNumber(props.data.data?.overview.phone);
				setCountryCode(parsed.countryCallingCode)
				setPhone(parsed.number)
			}

			if (props.data.data?.overview.occupation) {
				setOccupation({
					label: props.data.data?.overview.occupation,
					value: props.data.data?.overview.occupation_id
				})
			}

			if (props.data.data?.overview.email) {
				setEmail(props.data.data?.overview.email)
			}
			if (props.data.data?.overview.wealth_source) {
				setWealthSource({
					label: props.data.data?.overview.wealth_source,
					value: props.data.data?.overview.wealth_source_id
				})
			}

			if (props.data.data?.overview.annual_income) {
				setAnnualIncome(props.data.data?.overview.annual_income)
			}

			if (props.data.data.kyc?.address?.permanent_address?.address_line1) {
				setPermanentAddressLine1(props.data.data.kyc?.address?.permanent_address?.address_line1)
			}
			if (props.data.data.kyc?.address?.permanent_address?.address_line2) {
				setPermanentAddressLine2(props.data.data.kyc?.address?.permanent_address?.address_line2)
			}
			if (props.data.data.kyc?.address?.permanent_address?.pincode) {
				setPermanentPin(props.data.data.kyc?.address?.permanent_address?.pincode)
			}

			if (props.data.data.kyc?.address?.permanent_address?.address_country_id) {
				setPermanentCountry({
					label: props.data.data.kyc?.address?.permanent_address?.address_country_name,
					value: props.data.data.kyc?.address?.permanent_address?.address_country_id
				})
			}

			if (props.data.data.kyc?.address?.permanent_address?.address_state_id && props.data.data.kyc?.address?.permanent_address?.state) {
				setPermanentState({
					label: props.data.data.kyc?.address?.permanent_address?.state_address,
					value: props.data.data.kyc?.address?.permanent_address?.address_state_id
				});
				setStatePName({
					label: props.data.data.kyc?.address?.permanent_address?.state,
					value: props.data.data.kyc?.address?.permanent_address?.address_state_id
				});
				if (props.data.type === 2) {
					_getCities(props.data.data.kyc?.address?.permanent_address?.address_state_id, 1)
				}
			}

			if (props.data.data.kyc?.address?.permanent_address?.state_address !== null && props.data.data.kyc?.address?.permanent_address?.address_state_id === null) {
				setPermanentState({
					label: props.data.data.kyc?.address?.permanent_address?.state_address,
					value: props.data.data.kyc?.address?.permanent_address?.address_state_id
				});

				setStatePName({
					label: props.data.data.kyc?.address?.permanent_address?.state_address,
					value: props.data.data.kyc?.address?.permanent_address?.address_state_id
				});
			}


			// If id which is dropdown
			if (props.data.data.kyc?.address?.permanent_address?.address_city_id && props.data.data.kyc?.address?.permanent_address?.city) {
				setPermanentCity({
					label: props.data.data.kyc?.address?.permanent_address?.city,
					value: props.data.data.kyc?.address?.permanent_address?.address_city_id
				})
			}

			// If text which is input
			if (props.data.data.kyc?.address?.permanent_address?.address_city !== null && props.data.data.kyc?.address?.permanent_address?.address_city_id === null) {
				setCityPName({
					label: props.data.data.kyc?.address?.permanent_address?.address_city,
					value: props.data.data.kyc?.address?.permanent_address?.address_city
				})
			}


			if (props.data.data.kyc?.address?.correspondence_address?.address_line1) {
				setCorrespondanceAddressLine1(props.data.data.kyc?.address?.correspondence_address?.address_line1)
			}
			if (props.data.data.kyc?.address?.correspondence_address?.address_line2) {
				setCorrespondanceAddressLine2(props.data.data.kyc?.address?.correspondence_address?.address_line2)
			}
			if (props.data.data.kyc?.address?.correspondence_address?.pincode) {
				setCorrespondancePin(props.data.data.kyc?.address?.correspondence_address?.pincode)
			}

			if (props.data.data.kyc?.address?.correspondence_address?.address_country_id) {
				setCorrespondanceCountry({
					label: props.data.data.kyc?.address?.correspondence_address?.address_country_name,
					value: props.data.data.kyc?.address?.correspondence_address?.address_country_id
				})
			}

			if (props.data.data.kyc?.address?.correspondence_address?.address_state_id && props.data.data.kyc?.address?.correspondence_address?.state) {
				setCorrespondanceState({
					label: props.data.data.kyc?.address?.correspondence_address?.state,
					value: props.data.data.kyc?.address?.correspondence_address?.address_state_id
				});
				if (props.data.type === 2) {
					_getCities(props.data.data.kyc?.address?.correspondence_address?.address_state_id, 2)
				}
			}
			if (props.data.data.kyc?.address?.correspondence_address?.state_address !== null && props.data.data.kyc?.address?.correspondence_address?.address_state_id === null) {
				setStateCName({
					label: props.data.data.kyc?.address?.correspondence_address?.state_address,
					value: props.data.data.kyc?.address?.correspondence_address?.state_address
				});
			}


			if (props.data.data.kyc?.address?.correspondence_address?.address_city_id && props.data.data.kyc?.address?.correspondence_address?.city) {
				setCorresspondanceCity({
					label: props.data.data.kyc?.address?.correspondence_address?.city,
					value: props.data.data.kyc?.address?.correspondence_address?.address_city_id,
				})
			}
			if (props.data.data.kyc?.address?.correspondence_address?.address_city !== null && props.data.data.kyc?.address?.correspondence_address?.address_city_id === null) {
				setCityCName({
					label: props.data.data.kyc?.address?.correspondence_address?.address_city,
					value: props.data.data.kyc?.address?.correspondence_address?.address_city,
				})
			}

			setIsSame(props.data.data?.kyc?.address?.same_correspondence);

			if (props.data?.data?.is_nominee_available) {
				setNomineeDetails(props.data.data?.nominee_detail.map((item, idx) => {
					const IS_MINOR = moment().diff(moment(item.dob, "DD-MM-YYYY"), "years") < 18;
					return ({
						email: IS_MINOR ? item.guardian_contact_details ? item.guardian_contact_details?.email : '' : item.contact_detail ? item.contact_detail?.email : '',
						mobile: IS_MINOR ? item.guardian_contact_details ? `${item.guardian_contact_details.country_code}${item.guardian_contact_details.mobile}` : '' : item.contact_detail ? `${item.contact_detail.country_code}${item.contact_detail.mobile}` : '',
						country_code: IS_MINOR ? item.guardian_contact_details ? item.guardian_contact_details.country_code : '' : item.contact_detail ? item.contact_detail.country_code : '',
						address_line1: IS_MINOR ? item.guardian_address ? item.guardian_address.line1 : '' : item.address ? item.address.line_1 : '',
						state: IS_MINOR ?
							item.guardian_address &&
								item.guardian_address.guardian_state && item.guardian_address.state_id ?
								{ label: item.guardian_address.guardian_state, value: item.guardian_address.state_id } : null
							:
							item.address && item.address.nominee_state && item.address.state_id ?
								{ label: item.address.nominee_state, value: item.address.state_id } : null,
						city: IS_MINOR ?
							item.guardian_address && item.guardian_address.guardian_city && item.guardian_address.city_id ?
								{ label: item.guardian_address.guardian_city, value: item.guardian_address.city_id } :
								{ label: item.guardian_address.guardian_city, value: null }
							:
							item.address && item.address.city && item.address.city_id ?
								{ label: item.address.city, value: item.address.city_id } :
								{ label: item.address?.city, value: null },
						state_name: IS_MINOR ?
							item.guardian_address && item.guardian_address.state && item.guardian_address.state_id === null ?
								{ label: item.guardian_address.state, value: item.guardian_address.state } : ""
							:
							item.address && item.address.state && item.address.state_id === null ?
								{ label: item.address.state, value: item.address.state } : "",
						city_name: IS_MINOR ?
							item.guardian_address ?
								{ label: item.guardian_address.city, value: item.guardian_address.city }
								: null
							: item.address ?
								{ label: item.address.city, value: item.address.city } : null,
						country: IS_MINOR ? item.guardian_address ? { label: item.guardian_address.country_name, value: item.guardian_address.country_id } : null
							: item.address ? { label: item.address.country_name, value: item.address.country_id } : null,
						pincode: IS_MINOR ? item.guardian_address?.pincode : item.address?.pincode,
						nominee_relationship: { label: item.relation_name, value: item.relation_id },
						proof_number: IS_MINOR ? item.guardian_id_proof_number?.toLocaleUpperCase() : item.id_proof_number?.toLocaleUpperCase(),
						guardian_relationship: { label: item.guardian_relationship_name, value: item.guardian_relationship_id },
						proof_type: IS_MINOR ? { label: item.guardian_proof_type_name, value: item.guardian_proof_type } : { label: item.identity_proof_name, value: item.identity_proof_type },
						cityOptions: _getNomineeCities(IS_MINOR ? item.guardian_address?.state_id : item.address?.state_id, 3, idx) ?? [],
						...item
					})
				}))
				setNomineeTabs(props.data.data?.nominee_detail.map((item, index) => (`Nominee ${index + 1}`)));
			}
			setNomineeVisibility(props.data?.data?.nominee_visibility_status);
			setNomineeAvailable(props.data?.data?.is_nominee_available);

		}
	}, [props.data]);

	useEffect(() => {
		if (toastMessage !== null) {
			setTimeout(() => {
				setToastMessage(null);
			}, 4000);
		}
	}, [toastMessage])

	useEffect(() => {
		var detailModal = document.getElementById('editDetails');
		detailModal.addEventListener('hidden.bs.modal', async function () {
			props.close()
		});
	}, [props.close]);

	useEffect(() => {
		setTimeout(() => {
			setError(null);
		}, 3000);
	}, [error]);

	useEffect(() => {
		_getData();
		_getCountries();
		_getStates();
	}, [])


	/*----- edit personal detail api ----*/
	const _editPersonalDetails = () => {
		if (props.data.type === 1) {
			if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {

				setToastMessage({
					type: "error",
					message: "Enter valid email"
				});
				return false;
			}
			if (phone.length < 10) {

				setToastMessage({
					type: "error",
					message: "Enter valid phone number"
				});
				return false;
			}
		}
		if (props.data.type === 5 && nomineeAvailable) {

			for (let i = 0; i < nomineeDetails.length; i++) {
				const element = nomineeDetails[i]
				const IS_MINOR = moment().diff(moment(element.dob, "DD-MM-YYYY"), "years") < 18;
				const validNumber = parsePhoneNumber(element.mobile)
				if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(element.guardian_pan?.toLocaleUpperCase()) && IS_MINOR) {
					setToastMessage({
						type: "error",
						message: `Invalid Guardian PAN of Nominee${i + 1}`
					});
					return false;
				}
				if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(element.proof_number?.toLocaleUpperCase()) && element.proof_type?.label === "PAN") {
					setToastMessage({
						type: "error",
						message: `Invalid PAN proof of Nominee${i + 1}`
					});
					return false;
				}
				if (element.proof_number?.length < 4 && element.proof_type?.label === "Aadhaar") {
					setToastMessage({
						type: "error",
						message: `Invalid Aadhar proof of Nominee${i + 1}`
					});
					return false;
				}

				if (!validNumber?.isValid()) {
					setToastMessage({
						type: "error",
						message: `Invalid phone of Nominee ${i + 1}`
					});
					return false;
				}
				if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(element.email)) {
					setToastMessage({
						type: "error",
						message: `Invalid email of Nominee${i + 1}`
					});
					return false;
				}



			}
		}

		const nominees = nomineeDetails.map((item, idx) => {

			const IS_MINOR = moment().diff(moment(item.dob, "DD-MM-YYYY"), "years") < 18;
			const validNumber = parsePhoneNumber(item.mobile)
			return (
				{
					"nominee_id": item.nominee_id ? item.nominee_id : null,
					"name": item.name,
					"relation_id": item.nominee_relationship?.value,
					"dob": item.dob,
					"allocation": item.allocation,
					"identity_proof_type": IS_MINOR ? null : item.proof_type?.value,
					"identity_proof_number": IS_MINOR ? null : item.proof_number,
					"contact_detail": IS_MINOR ? null : {
						"email": IS_MINOR ? null : item.email,
						"country_code": IS_MINOR ? null : item.country_code,
						"phone_number": IS_MINOR ? null : validNumber?.nationalNumber,
					},
					"nominee_address": IS_MINOR ? null : {
						"address_line1": IS_MINOR ? null : item.address_line1,
						"state_id": IS_MINOR ? null : item.state ? item.state?.value : null,
						"city_id": IS_MINOR ? null : item.city ? item.city?.value : null,
						"pincode": IS_MINOR ? null : item.pincode,
						"city": IS_MINOR ? null : item.city_name ? item.city_name?.value : null,
						"state_name": IS_MINOR ? null : item.state_name ? item.state_name?.value : null,
						"country_id": IS_MINOR ? null : item.country?.value
					},
					"guardian_name": IS_MINOR ? item.guardian_name : null,
					"guardian_relationship_id": IS_MINOR ? item.guardian_relationship?.value : null,
					"guardian_pan": IS_MINOR ? item.guardian_pan : null,
					"guardian_id_proof_type": IS_MINOR ? item.proof_type?.value : null,
					"guardian_id_proof_number": IS_MINOR ? item.proof_number : null,
					"guardian_contact_detail": IS_MINOR ? {
						"email": IS_MINOR ? item.email : null,
						"country_code": IS_MINOR ? item.country_code : null,
						"phone_number": IS_MINOR ? validNumber?.nationalNumber : null,
					} : null,
					"guardian_address": IS_MINOR ? {
						"address_line1": IS_MINOR ? item.address_line1 : null,
						"state_id": IS_MINOR ? item.state ? item.state?.value : null : null,
						"city_id": IS_MINOR ? item.city ? item.city?.value : null : null,
						"pincode": IS_MINOR ? item.pincode : null,
						"city": IS_MINOR ? item.city_name ? item.city_name?.value : null : null,
						"state_name": IS_MINOR ? item.state_name ? item.state_name?.value : null : null,
						"country_id": IS_MINOR ? item.country?.value : null
					} : null
				}
			)
		})
		setApiLoader(true)
		let url = devconfig.admin + '/user/update-customer-detail'

		console.log('permanentState', permanentState)
		let data = JSON.stringify({
			"customer_id": props.userId,
			"dob": dob ? dob : null,
			"gender_id": gender ? gender?.value : null,
			"occupation_id": occupation ? occupation?.value : null,
			"marital_status_id": maritalStatus ? maritalStatus?.value : null,
			"annual_income": annualIncome ? annualIncome : null,
			"is_same_corresponding_address": isSame,
			"address": {
				"permanent_address": {
					"address_line1": permanentAddressLine1 ? permanentAddressLine1 : null,
					"address_line2": permanentAddressLine2 ? permanentAddressLine2 : null,
					"state_id": permanentState ? permanentState?.value : null,
					"city_id": permanentCity ? permanentCity?.value : null,
					"pincode": permanentPin ? permanentPin : null,
					"city": cityPName ? cityPName?.value : null,
					"state_name": permanentState ? permanentState?.label : statePName ? statePName.label : null,
					"country_id": permanentCountry ? permanentCountry?.value : null
				},
				"corresponding_address": isSame ? null : {
					"address_line1": correspondanceAddressLine1,
					"address_line2": correspondanceAddressLine2,
					"state_id": correspondanceState ? correspondanceState?.value : null,
					"city_id": corresspondanceCity ? corresspondanceCity?.value : null,
					"pincode": correspondancePin,
					"city": cityCName ? cityCName?.value : null,
					"state_name": stateCName ? stateCName?.value : null,
					"country_id": correspondanceCountry?.value
				}
			},
			"income_source_id": wealthSource ? wealthSource?.value : null,
			"name": name ? name : null,
			"country_code": "+" + countryCode,
			"phone": phone ? phone.slice(countryCode.length + 1,) : null,
			"email": email ? email : null,
			"nominee": nomineeAvailable ? nominees : [],
			"nominee_visibility_status": nomineeVisibility,
			"is_nominee_available": nomineeAvailable

		});
		APIPost(url, data).then((response) => {
			if (response.status_code === 200) {
				setToastMessage({
					type: "success",
					message: `${props.section} has been added`
				})
				$('#closebtn').trigger('click');
				props.editUserDetails(true, nomineeAvailable)
			} else {
				setToastMessage({
					type: "error",
					message: response.message
				})
			}
			setApiLoader(false);
		})
	}
	/* --- select box options ---*/
	const _getData = () => {
		let tempOccupation = [];
		let tempMarital = [];
		let tempWealthSource = [];
		let tempGender = [];
		let url = devconfig.admin + '/general/get';
		APIGet(url).then((response) => {
			if (response?.status_code === 200) {
				//eslint-disable-next-line
				response.data.genders.map((item, key) => {
					tempGender.push({ value: item.id, label: item.display_name })
				})
				//eslint-disable-next-line
				response.data.occupation.map((item, key) => {
					tempOccupation.push({ value: item.id, label: item.display_name })
				})
				//eslint-disable-next-line
				response.data.source_of_wealths.map((item, key) => {
					tempWealthSource.push({ value: item.id, label: item.display_name })
				})

				//eslint-disable-next-line
				response.data.marital_statuses.map((item, key) => {
					tempMarital.push({ value: item.id, label: item.display_name })
				})

				setIdentityProofTypes(response.data.nominee_id_proof_type.map((item) => ({
					label: item.display_name,
					value: item.id
				})))
				setNomineeRelations(response.data.kyc_relationship.map((item) => ({
					label: item.display_name,
					value: item.id
				})))
				setGuardianRelations(response.data.nominee_minor_relation.map((item) => ({
					label: item.display_name,
					value: item.id
				})))
				setNominivisibilityStatuses(response.data.nominee_visibility_status.map((item) => ({
					label: item.display_name,
					id: item.id
				})))
				setNomineeVisibility(response.data.nominee_visibility_status[0].id);
				setGenderOptions(tempGender);
				setOccupationOptions(tempOccupation);
				setSourceOptions(tempWealthSource);
				setMaritalOptions(tempMarital);

			}
			else {
				setError(response?.message)
			}
		})
		setTimeout(() => {
			setError(null)
		}, 3000)
	}

	/* --- select box options ---*/
	const _getCountries = () => {

		let url = devconfig.admin + '/general/countries';
		APIGet(url).then((response) => {
			if (response?.status_code === 200) {
				setCountryOptions(response.data.countries_for_address.map((item) => ({
					label: item.name,
					value: item.id
				})))
			}
			else {
				setCountryOptions([]);
			}
		})

	}

	/* --- select box options ---*/
	const _getStates = () => {

		let url = devconfig.admin + '/general/states';
		APIGet(url).then((response) => {
			if (response?.status_code === 200) {
				setStateOptions(response.data.map((item) => ({
					label: item.name,
					value: item.id
				})))
			}
			else {
				setStateOptions([])
			}
		})
	}

	function _handleDeleteNominee(index) {
		const nominee_details = [...nomineeDetails]
		nominee_details.splice(index, 1);
		setNomineeTabs(nominee_details.map((item, index) => `Nominee ${index + 1}`))
		setNomineeDetails(nominee_details);
		setSelectedNominee(nominee_details.length);
	}

	/* --- select box options ---*/
	const _getNomineeCities = (state_id, type, index) => {


		let url = devconfig.admin + '/general/cities';
		let payload = JSON.stringify({
			state_id: state_id
		})
		setNomineeDetails((prev) => {
			const nominee = [...prev];

			// Prevent potential crash on undefined index
			// if (!nominee[index]) return prev;

			nominee[index] = {
				...nominee[index],

			};

			APIPost(url, payload).then((response) => {
				if (response.status_code === 200) {
					const cities = response.data.map((item) => ({
						label: item.name,
						value: item.id
					}));

					// Update states again after async call
					setNomineeDetails((prevNominee) => {
						const updated = [...prevNominee];
						if (!updated[index]) return prevNominee;

						updated[index] = {
							...updated[index],
							cityOptions: cities
						};
						return updated;
					});
				}
			});

			return nominee;
		});
	}
	/* --- select box options ---*/
	const _getCities = (state_id, type, index) => {


		let url = devconfig.admin + '/general/cities';
		let payload = JSON.stringify({
			state_id: state_id
		})

		APIPost(url, payload).then((response) => {
			if (response?.status_code === 200) {

				if (type === 1) {
					setCityOptions(response.data.map((item) => ({
						label: item.name,
						value: item.id
					})))
				} else if (type === 2) {
					setCityOptions1(response.data.map((item) => ({
						label: item.name,
						value: item.id
					})))
				}
			}
			else {
				if (type === 1) {
					setCityOptions([]);
				} else if (type === 2) {
					setCityOptions1([]);
				}
			}
		})

	}

	const disabledDate18 = (current) => {
		if (current.isAfter(moment().subtract(18, "years"))) {
			return true
		}
	}

	const disabledDate = (current) => {
		if (current.isAfter(moment().subtract(1, "days"))) {
			return true
		}
	}

	function _handleValueChange(value, index, key) {
		const nominee_detail = [...nomineeDetails]
		nominee_detail[index][key] = value
		setNomineeDetails(nominee_detail);
	}

	function _addNominee() {
		if (props.data.type === 5 && nomineeAvailable) {

			for (let i = 0; i < nomineeDetails.length; i++) {
				const element = nomineeDetails[i]
				const IS_MINOR = moment().diff(moment(element.dob, "DD-MM-YYYY"), "years") < 18;
				const validNumber = parsePhoneNumber(element.mobile)
				if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(element.guardian_pan?.toLocaleUpperCase()) && IS_MINOR) {
					setToastMessage({
						type: "error",
						message: `Invalid Guardian PAN of Nominee${i + 1}`
					});
					return false;
				}
				if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(element.proof_number?.toLocaleUpperCase()) && element.proof_type?.label === "PAN") {
					setToastMessage({
						type: "error",
						message: `Invalid PAN proof of Nominee${i + 1}`
					});
					return false;
				}
				if (element.proof_number?.length < 4 && element.proof_type?.label === "Aadhaar") {
					setToastMessage({
						type: "error",
						message: `Invalid Aadhar proof of Nominee${i + 1}`
					});
					return false;
				}

				if (!validNumber?.isValid()) {
					setToastMessage({
						type: "error",
						message: `Invalid phone of Nominee ${i + 1}`
					});
					return false;
				}
				if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(element.email)) {
					setToastMessage({
						type: "error",
						message: `Invalid email of Nominee${i + 1}`
					});
					return false;
				}
			}
		}
		const nominee_detail = [...nomineeDetails]
		nominee_detail.push({
			nominee_id: null,
			email: "",
			mobile: "",
			country_code: "+91",
			address_line1: "",
			state: null,
			state_name: "",
			city: null,
			city_name: "",
			country: {
				label: "India",
				value: 251
			},
			pincode: "",
			nominee_relationship: null,
			proof_number: "",
			guardian_relationship: null,
			proof_type: null,
			cityOptions: [],
			name: "",
			dob: null,
			allocation: "",
			guardian_name: "",
			guardian_pan: "",
		})
		const nominee_tabs = [...nomineeTabs]
		nominee_tabs.push(`Nominee ${nominee_detail.length}`);
		setNomineeTabs(nominee_tabs);
		setNomineeDetails(nominee_detail);
	}

	const validateForm = () => {
		if (props?.data?.type === 1) {
			if (name && dob && gender && maritalStatus && phone && email && occupation && annualIncome && wealthSource) {
				return true
			} else {
				return false
			}
		}
		else if (props?.data?.type === 2) {
			if (isSame && permanentAddressLine1 && permanentAddressLine2 && permanentCountry && (permanentState || statePName) && (permanentCity || cityPName) && permanentPin.length >= 4) {
				return true
			} else if (!isSame && permanentAddressLine1 && permanentAddressLine2 && permanentCountry && (permanentState || statePName) && (permanentCity || cityPName) && permanentPin.length >= 4
				&& correspondanceAddressLine1 && correspondanceAddressLine2 && correspondanceCountry && (correspondanceState || stateCName) && (corresspondanceCity || cityCName) && correspondancePin.length >= 4
			) {
				return true
			} else {
				return false
			}
		}
		else {
			if (nomineeAvailable) {
				const isValidNominees = nomineeDetails.every((nominee_detail) => {
					if (!nominee_detail) return false;

					const IS_MINOR = moment().diff(
						moment(nominee_detail.dob, "DD-MM-YYYY"),
						"years"
					) < 18;

					// ✅ Adult nominee
					if (!IS_MINOR) {
						return (
							!!nominee_detail.name &&
							!!nominee_detail.nominee_relationship &&
							!!nominee_detail.dob &&
							!!nominee_detail.allocation &&
							!!nominee_detail.proof_type &&
							!!nominee_detail.proof_number &&
							!!nominee_detail.mobile &&
							!!nominee_detail.email &&
							!!nominee_detail.address_line1 &&
							!!nominee_detail.country &&
							(!!nominee_detail.state || !!nominee_detail.state_name) &&
							(!!nominee_detail.city || !!nominee_detail.city_name) &&
							nominee_detail.pincode?.length === 6
						);
					}

					// ✅ Minor nominee (extra guardian fields required)
					return (
						!!nominee_detail.name &&
						!!nominee_detail.nominee_relationship &&
						!!nominee_detail.dob &&
						!!nominee_detail.allocation &&
						!!nominee_detail.proof_type &&
						!!nominee_detail.proof_number &&
						!!nominee_detail.mobile &&
						!!nominee_detail.email &&
						!!nominee_detail.address_line1 &&
						!!nominee_detail.country &&
						(!!nominee_detail.state || !!nominee_detail.state_name) &&
						(!!nominee_detail.city || !!nominee_detail.city_name) &&
						nominee_detail.pincode?.length === 6 &&
						!!nominee_detail.guardian_name &&
						!!nominee_detail.guardian_pan &&
						!!nominee_detail.guardian_relationship
					);
				});

				return isValidNominees
			} else {
				return true
			}


		}
	}



	return (
		<div className={`${styles.e_add_faq} modal fade`} id='editDetails' tabIndex="-1" aria-labelledby="success" aria-hidden="true">
			<div className="modal-dialog modal-dialog-centered">
				<div className="modal-content">
					<div className="modal-header">
						<h6>Update {props.data?.type === 1 ? "Personal" : props.data?.type === 2 ? "Address" : "Nominee"} details</h6>
						<button id="closebtn" type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div className="container px-3">
						{
							props.data.type === 1 ?
								<div>
									<div className="row">
										<div className="col-lg-6">
											<label>Name </label>
											<Input placeholder="Name"
												value={name}
												valueChange={(value) => {
													setName(value)
												}}
												type="text" />
										</div>
										<div className="col-lg-6">
											<label>DOB</label>
											<Datepicker value={dob}
												disabledDate={disabledDate18}
												isDecadeBack
												onChange={(value) => {
													setDob(value)
												}}
												type="text" />
										</div>
										<div className="col-lg-6 pt-3">
											<label>Gender</label>
											<SelectBox placeholder="Gender"
												isSearchable={false}
												value={gender}
												options={genderOptions}
												selectchange={(temp) => {
													setGender(temp);
												}} />
										</div>

										<div className="col-lg-6 pt-3">
											<label>Marital status</label>
											<SelectBox isSearchable={false}
												value={maritalStatus}
												placeholder="Marital status"
												options={maritalOptions}
												selectchange={(temp) => {
													setMaritalStatus(temp);
												}} />
										</div>
										<div className="col-lg-6 pt-3">
											<label>Phone</label>
											<PhoneInput countryCode={countryCode}
												placeholder="Phone"
												value={phone}
												valueChange={(value, number) => {
													if (value) {
														let phoneNumber = parsePhoneNumber(value)
														setPhone(phoneNumber ? phoneNumber?.number : value);
														setCountryCode(phoneNumber ? phoneNumber.countryCallingCode : value);
													}
												}} />
										</div>
										<div className="col-lg-6 pt-3">
											<label>Email</label>
											<Input value={email}
												placeholder="Email"
												valueChange={(value) => {
													setEmail(value)
												}}
												type="email" />
										</div>

										<div className="col-lg-6 pt-3">
											<label>Occupation</label>
											<SelectBox placeholder="Occupation"
												isSearchable={false}
												value={occupation}
												options={occupationOptions}
												selectchange={(temp) => { setOccupation(temp); }} />
										</div>
										<div className="col-lg-6 pt-3">
											<label>Annual income</label>
											<Input isSearchable={false}
												placeholder="Annual income"
												value={annualIncome}
												type="number"
												valueChange={(temp) => {
													setAnnualIncome(temp);
												}} />
										</div>
										<div className="col-lg-6 pt-3">
											<label>Source of wealth</label>
											<SelectBox isSearchable={false}
												placeholder="Income source"
												value={wealthSource}
												options={sourceOptions}
												selectchange={(temp) => {
													setWealthSource(temp);
												}} />
										</div>
									</div>

								</div>
								:
								props.data.type === 2 ?
									<div>
										<h6 className='mb-1'>Permanent Address</h6>

										<div className='row'>
											<div className='col-lg-6'>
												<label>Address Line 1</label>
												<Input value={permanentAddressLine1}
													placeholder="Address Line 1"
													valueChange={(value) => {
														setPermanentAddressLine1(value)
													}}
													type="text" />
											</div>
											<div className='col-lg-6'>
												<label>Address Line 2</label>
												<Input value={permanentAddressLine2}
													placeholder="Address Line 2"
													valueChange={(value) => {
														setPermanentAddressLine2(value)
													}}
													type="text" />
											</div>
											<div className="col-lg-6 pt-3">
												<label>Country</label>
												<SelectBox isSearchable={true}
													value={permanentCountry}
													options={countryOptions}
													placeholder="Select Country"
													selectchange={(temp) => {
														setPermanentCountry(temp);
														setCorrespondanceState(null);
														setStatePName("");
													}} />
											</div>
											<div className="col-lg-6 pt-3">
												<label>State</label>
												{
													(permanentCountry?.value !== 251) ?
														<Input value={statePName ? statePName?.label : ""}
															placeholder="State"
															valueChange={(temp) => {
																setStatePName({
																	label: temp,
																	value: temp
																});
																setPermanentState(null);
															}} />
														:
														<SelectBox isSearchable={true}
															value={statePName ? statePName : permanentState}
															options={stateOptions}
															placeholder="Select State"
															type={2}
															selectchange={(temp) => {
																if (!isNaN(temp.value)) {
																	setPermanentState(temp);
																	_getCities(temp?.value, 1)
																	setStatePName("");
																} else {
																	setStatePName(temp);
																	setPermanentState(null);
																}
																setPermanentCity(null);
																setCityPName("");
															}} />
												}
											</div>
											<div className="col-lg-6 pt-3">
												<label>City</label>
												{
													(permanentCountry?.value !== 251) ?
														<Input value={cityPName ? cityPName?.value : ""}
															placeholder="City"
															valueChange={(temp) => {
																setCityPName({
																	label: temp,
																	value: temp
																});
																setPermanentCity(null);
															}} />
														: <SelectBox isSearchable={true}
															placeholder="Select City"
															value={cityPName ? cityPName : permanentCity}
															type={2}
															options={cityOptions}
															isDisabled={permanentState === null && statePName == ""}
															selectchange={(temp) => {
																if (!isNaN(temp.value)) {
																	setPermanentCity(temp);
																	setCityPName(null);
																} else {
																	setCityPName(temp);
																	setPermanentCity(null);
																}

															}} />
												}
											</div>
											<div className='col-lg-6 pt-3'>
												<label>Pincode</label>
												<Input value={parseInt(permanentPin)}
													placeholder="Pincode"
													valueChange={(value) => {
														if (value.length <= 6) {
															setPermanentPin(value)
														}
													}} type="number" />
											</div>
										</div>

										<div className='d-flex align-items-center mt-3'>

											<Input type="checkbox"
												id="e-select"
												className="cursor-pointer"
												checked={isSame}
												valueChange={() => setIsSame(!isSame)} />
											<p className={` ms-2 mb-0`} style={{ fontSize: "13px" }}>Same as Permanent Address</p>
										</div>



										{!isSame && <div className='row pt-4'>
											<h6 className='mb-1'>Corresponding Address</h6>
											<div className='col-lg-6'>
												<label>Address Line 1</label>
												<Input value={correspondanceAddressLine1}
													placeholder="Address Line 1"
													valueChange={(value) => {
														setCorrespondanceAddressLine1(value)
													}} type="text" />
											</div>
											<div className='col-lg-6'>
												<label>Address Line 2</label>
												<Input value={correspondanceAddressLine2}
													placeholder="Address Line 2"
													valueChange={(value) => {
														setCorrespondanceAddressLine2(value)
													}} type="text" />
											</div>
											<div className="col-lg-6 pt-3">
												<label>Country</label>
												<SelectBox isSearchable={true}
													value={correspondanceCountry}
													options={countryOptions}
													placeholder="Select Country"
													selectchange={(temp) => {
														setCorrespondanceCountry(temp);
														setCorrespondanceState(null);
														setStateCName("");
													}} />
											</div>
											<div className="col-lg-6 pt-3">
												<label>State</label>
												{(correspondanceCountry?.value !== 251) ?
													<Input value={stateCName ? stateCName?.value : ""}
														placeholder="State"
														valueChange={(temp) => {
															setStateCName({
																label: temp,
																value: temp
															});
															setCorrespondanceState(null);
														}} />
													:
													<SelectBox isSearchable={true}
														placeholder="Select State"
														value={stateCName ? stateCName : correspondanceState}
														options={stateOptions}
														type={2}
														selectchange={(temp) => {
															if (!isNaN(temp.value)) {
																setCorrespondanceState(temp);
																setStateCName("");
																_getCities(temp.value, 2)
															} else {
																setStateCName(temp);
																setCorrespondanceState(null);
															}
															setCorresspondanceCity(null);
															setCityCName("");

														}} />}
											</div>
											<div className="col-lg-6 pt-3">
												<label>City</label>
												{(correspondanceCountry?.value !== 251) ?
													<Input value={cityCName ? cityCName?.value : ""}
														placeholder="City"
														valueChange={(temp) => {
															setCityCName({
																label: temp,
																value: temp
															});
															setCorresspondanceCity(null);
														}} />
													: <SelectBox isSearchable={true}
														placeholder="Select City"
														value={cityCName ? cityCName : corresspondanceCity}
														options={cityOptions1}
														type={2}
														selectchange={(temp) => {
															if (!isNaN(temp.value)) {
																setCorresspondanceCity(temp);
																setCityCName("");
															} else {
																setCityCName(temp);
																setCorresspondanceCity(null);
															}

														}} />}
											</div>
											<div className='col-lg-6 pt-3'>
												<label>Pincode</label>
												<Input value={parseInt(correspondancePin)}
													placeholder="Pincode"
													valueChange={(value) => {
														if (value.length <= 6) {
															setCorrespondancePin(value)
														}
													}} type="number" />
											</div>
										</div>}

									</div>
									:
									props.data.type === 5 ?
										<>
											<div className="row">
												<label className='pt-3 pb-0'>Do you want to add a nominee to your investment account?</label>
												<div className="col-lg-2">
													<Radio id={1} value={true} className="mt-1" label="Yes" valueClick={(e) => setNomineeAvailable(true)} name="check" checked={nomineeAvailable === true ? true : false} />
												</div>

												<div className="col-lg-2">
													<Radio id={2} value={false} className="mt-1" label="No" valueClick={(e) => setNomineeAvailable(false)} name="check1" checked={nomineeAvailable === false ? true : false} />
												</div>

											</div>

											{nomineeAvailable === true && <FundsTab data={nomineeTabs}
												index={selectedNominee}
												className="e-horizontal-scroll"
												setTab={(tab) => setSelectedNominee(tab)} />}

											{nomineeAvailable === true &&
												nomineeDetails.map((item, idx) => {
													console.log('itme', item);
													const IS_MINOR = moment().diff(moment(item.dob, "DD-MM-YYYY"), "years") < 18;
													if (idx === (selectedNominee - 1)) {
														return (
															<>
																<div className="row mt-4">
																	<div className="col-lg-6">
																		<h6 className='d-flex align-items-center'>Nominee {idx + 1}
																			{nomineeDetails.length > 1 && <img
																				src={require('../../assets/images/modal/delete.svg').default}
																				alt="Delete"
																				width={20}
																				className="cursor-pointer ms-2"
																				onClick={() => _handleDeleteNominee(idx)}
																			/>}
																		</h6>
																	</div>

																</div>
																<div className={`${styles.e_nominee_height}`}>
																	<div className="row ">
																		<div className="col-lg-6">
																			<label>Name</label>
																			<Input placeholder="Name"
																				value={item.name}
																				valueChange={(value) => {
																					_handleValueChange(value, idx, "name");
																				}}
																				type="text" />
																		</div>
																		<div className="col-lg-6">
																			<label>Nominee relationship</label>
																			<SelectBox isSearchable={false}
																				placeholder="Nominee relationship"
																				value={item.nominee_relationship}
																				options={nomineeRelations}
																				selectchange={(temp) => {
																					_handleValueChange(temp, idx, "nominee_relationship");
																				}} />
																		</div>
																		<div className="col-lg-6 pt-3">
																			<label>DOB</label>
																			<Datepicker value={item.dob}
																				disabledDate={disabledDate}
																				onChange={(value) => {
																					_handleValueChange(value, idx, "dob");
																				}}
																			/>
																		</div>
																		<div className="col-lg-6 pt-3">
																			<label>Allocation</label>
																			<Input placeholder="Allocation"
																				value={item.allocation}
																				valueChange={(value) => {
																					if (value <= 100) {
																						_handleValueChange(value, idx, "allocation");
																					}
																				}}
																				type="number" />
																		</div>
																		{IS_MINOR && <div className="col-lg-6 pt-3">
																			<label>Guardian Name</label>
																			<Input placeholder="Guardian name"
																				value={item.guardian_name}
																				valueChange={(value) => {
																					_handleValueChange(value, idx, "guardian_name");
																				}}
																				type="text" />
																		</div>}
																		{IS_MINOR && <div className="col-lg-6 pt-3">
																			<label>Guardian relationship</label>
																			<SelectBox isSearchable={false}
																				placeholder="Guardian relationship"
																				value={item.guardian_relationship}
																				options={guardianRelations}
																				selectchange={(temp) => {
																					_handleValueChange(temp, idx, "guardian_relationship");
																				}} />
																		</div>}
																		{IS_MINOR && <div className="col-lg-6 pt-3">
																			<label>Guardian PAN</label>
																			<Input placeholder="Guardian PAN"
																				className={"text-uppercase"}
																				value={item.guardian_pan}
																				valueChange={(temp) => {
																					_handleValueChange(temp?.toLocaleUpperCase(), idx, "guardian_pan");
																				}} />
																		</div>}

																		<div className="col-lg-6 pt-3">
																			{
																				IS_MINOR ?
																					<label>Guardian Identity Proof type</label>
																					:
																					<label>Identity Proof type</label>
																			}

																			<SelectBox isSearchable={false}
																				placeholder="Identity proof type"
																				value={item.proof_type}
																				options={identityProofTypes}
																				selectchange={(temp) => {
																					_handleValueChange(temp, idx, "proof_type");
																					_handleValueChange("", idx, "proof_number");
																				}} />
																		</div>
																		<div className="col-lg-6 pt-3">
																			{
																				IS_MINOR ?
																					<label>Guardian Identity Proof number</label>
																					:
																					<label>Identity Proof number</label>
																			}

																			<Input placeholder={item.proof_type?.label === "Aadhaar" ? "Enter last 4 digits of Aadhaar" : "Identity proof number"}
																				value={item.proof_number}
																				className={"text-uppercase"}
																				type={item.proof_type?.label === "Aadhaar" ? "number" : "text"}
																				valueChange={(temp) => {
																					if (item.proof_type?.label === "Aadhaar") {
																						if (temp.length <= 4) {
																							_handleValueChange(temp, idx, "proof_number");
																						}
																					} else if (item.proof_type?.label === "PAN") {
																						if (temp.length <= 10) {
																							_handleValueChange(temp?.toLocaleUpperCase(), idx, "proof_number");
																						}
																					} else {
																						_handleValueChange(temp?.toLocaleUpperCase(), idx, "proof_number");
																					}
																				}} />
																		</div>
																		<div className="col-lg-6 pt-3">
																			{
																				IS_MINOR ?
																					<label>Guardian Phone</label>
																					:
																					<label>Phone</label>
																			}

																			<PhoneInput number={(val) => setPhone(val)}
																				countryCode={item.country_code}
																				placeholder="Phone"
																				value={item.mobile}
																				valueChange={(value, number) => {
																					if (value) {
																						let phoneNumber = parsePhoneNumber(value)
																						_handleValueChange(phoneNumber ? phoneNumber?.number : value, idx, "mobile");
																						_handleValueChange(phoneNumber ? `+${phoneNumber.countryCallingCode}` : value, idx, "country_code");
																					}
																				}} />
																		</div>
																		<div className={IS_MINOR ? "col-lg-12 pt-3" : "col-lg-6 pt-3"}>
																			{
																				IS_MINOR ?
																					<label>Guardian Email</label>
																					:
																					<label>Email</label>
																			}

																			<Input value={item.email}
																				placeholder="Email"
																				valueChange={(value) => {
																					_handleValueChange(value, idx, "email");
																				}}
																				type="email" />
																		</div>
																		<div className='col-lg-12 pt-3'>
																			<label>Address Line 1</label>
																			<TextArea value={item.address_line1}
																				placeholder="Address Line 1"
																				valueChange={(value) => {
																					_handleValueChange(value, idx, "address_line1");
																				}}
																				type="text" />
																		</div>
																		<div className="col-lg-6 pt-3">
																			<label>Country</label>
																			<SelectBox isSearchable={true}
																				value={item.country}
																				options={countryOptions}
																				placeholder="Select Country"
																				selectchange={(temp) => {
																					_handleValueChange(temp, idx, "country");
																					_handleValueChange(null, idx, "state");
																				}} />
																		</div>
																		<div className="col-lg-6 pt-3">
																			<label>State</label>
																			{(item.country?.value !== 251) ?
																				<Input value={item.state_name ? item.state_name?.value : ""}
																					placeholder="State"
																					valueChange={(temp) => {
																						const value = {
																							label: temp,
																							value: temp
																						}
																						_handleValueChange(value, idx, "state_name");
																						_handleValueChange(null, idx, "state");
																					}} />
																				: <SelectBox isSearchable={true}
																					value={item.state_name ? item.state_name : item.state}
																					options={stateOptions}
																					type={2}
																					placeholder="Select State"
																					selectchange={(temp) => {
																						if (!isNaN(temp.value)) {
																							_handleValueChange(temp, idx, "state");
																							_handleValueChange(null, idx, "city");
																							_handleValueChange("", idx, "state_name");
																							_getNomineeCities(temp?.value, 3, idx)
																						} else {
																							_handleValueChange(temp, idx, "state_name");
																							_handleValueChange("", idx, "city_name");
																							_handleValueChange(null, idx, "state");
																							_handleValueChange(null, idx, "city");
																						}
																					}} />}
																		</div>
																		<div className="col-lg-6 pt-3">
																			<label>City</label>
																			{console.log('jdiwj', item.city_name)}
																			{(item.country?.value !== 251) ?
																				<>
																					{console.log('jdiwj', item.city_name)}
																					<Input value={item.city_name ? item.city_name?.label : ""}
																						placeholder="City"
																						valueChange={(temp) => {
																							const value = {
																								label: temp,
																								value: temp
																							}
																							_handleValueChange(value, idx, "city_name");
																							_handleValueChange(null, idx, "city");
																						}} />
																				</>

																				: <SelectBox isSearchable={true}
																					placeholder="Select City"
																					value={item.city_name ? item.city_name : item.city}
																					options={item.cityOptions}
																					type={2}
																					isDisabled={item.state === null && item.state_name == ""}
																					selectchange={(temp) => {
																						if (!isNaN(temp.value)) {
																							_handleValueChange(temp, idx, "city");
																							_handleValueChange("", idx, "city_name");
																						} else {
																							_handleValueChange(null, idx, "city");
																							_handleValueChange(temp, idx, "city_name");
																						}
																					}} />}
																		</div>
																		<div className='col-lg-6 pt-3'>
																			<label>Pincode</label>
																			<Input value={item.pincode}
																				placeholder="Pincode"
																				valueChange={(value) => {
																					if (value.length <= 6) {
																						_handleValueChange(value, idx, "pincode");
																					}
																				}} type="number" />
																		</div>
																	</div>
																</div>
															</>
														)
													}
												})

											}
											<div className="row pt-3">
												<label className='pb-0'>Nominee visibility on account statement*</label>
												{
													nomineeVisibilityStatuses.map((item) => {
														return (
															<div className="col-lg-5">
																<Radio id={item.id} value={item.id} className="mt-1" label={item.label} valueClick={(e) => setNomineeVisibility(item.id)} name="check2" checked={nomineeVisibility === item.id ? true : false} />
															</div>
														)
													})
												}


											</div>
										</>

										:
										null
						}
						<div className="row pt-4 mt-2 pb-2">
							<div className={props.data.type === 5 && nomineeAvailable === true ? "col-lg-12 d-flex justify-content-between" : "col-lg-12 d-flex justify-content-end"}>
								{props.data.type === 5 && nomineeAvailable === true && <PrimaryBtn name="Add nominee" className={validateForm() ? "e-modal-submit px-5" : "e-modal-submit px-5 e-disabled"}
									handleClick={_addNominee} />}
								<div className="d-flex justify-content-end">
									<SecondaryBtn name="Cancel" className="e-cancel" cancel="modal" />
									{

										validateForm() ?
											<PrimaryBtn name="Save details" className={apiLoader ? "e-btn-loader e-disabled e-modal-submit" : "e-modal-submit"} handleClick={() => _editPersonalDetails()} />
											:
											<PrimaryBtn name="Save details" className="e-disabled e-modal-submit" />

									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{
				toastMessage !== null ?
					<Toast data={toastMessage.message}
						type={toastMessage.type}
						id="2" />
					:
					null
			}
		</div>
	)
}
